import { render, staticRenderFns } from "./FavouriteOptions.vue?vue&type=template&id=7d48e0aa&scoped=true&"
import script from "./FavouriteOptions.vue?vue&type=script&lang=ts&"
export * from "./FavouriteOptions.vue?vue&type=script&lang=ts&"
import style0 from "./FavouriteOptions.vue?vue&type=style&index=0&id=7d48e0aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48e0aa",
  null
  
)

export default component.exports